import { checkPermission } from "@shared/utils/functions";
import { getPermissionErrorMessages } from "@shared/utils/permissions/constants";

export default {
  computed: {
    isRunCheckAllowed() {
      return checkPermission("case.run_check");
    },
  },

  methods: {
    showRunCheckError() {
      this.$toast.error(getPermissionErrorMessages()["case.run_check"]);
    }
  },
};
